export const reducerNamespace = 'processTracker';
